<template>
  <div class="jdindentlist">
    <div class="jdindentList-top">
      <span class="el-icon-back" @click="goBack"></span>
      <div>需求详情</div>
    </div>
    <div class="result">
      <el-button type="primary" size="mini" @click="schemeDialogHandle">方案定制</el-button>
    </div>
    <div class="jdindentList-container">
      <div class="container_item">
        <h1>当前状态</h1>
        <el-steps :active="2" finish-status="success" simple>
          <el-step title="发布需求"></el-step>
          <el-step title="等待顾问响应"></el-step>
          <el-step title="待确认方案"></el-step>
          <el-step title="需求完成"></el-step>
        </el-steps>
      </div>
      <div class="container_item" style="height:100%">
        <h1>申请概览</h1>
        <div class="container_item_box">
          <div class="container_item_box_item">
            <div>
              <label>创建时间</label>
              <span>{{details.created_at||"--"}}</span>
            </div>
            <div>
              <label>需求ID</label>
              <span>{{details.needNo||"--"}}</span>
            </div>
            <!-- <div>
              <label>公司名称</label>
              <span>{{details.publishName}}</span>
            </div>-->
            <div>
              <label>联系人姓名</label>
              <span>{{details.followManName||"--"}}</span>
            </div>
            <div>
              <label>需求内容</label>
              <span>{{details.followContent||"--"}}</span>
            </div>
          </div>
          <div class="container_item_box_item">
            <div>
              <label>需求状态</label>
              <span>{{details.statusName||"--"}}</span>
            </div>
            <div>
              <label>需求类型</label>
              <span>{{details.typeName||details.notes||"--"}}</span>
            </div>
            <div>
              <label>申请区域</label>
              <span>{{details.city||"--"}}</span>
            </div>
            <div>
              <label>联系电话</label>
              <span>{{details.publishMobile||"--"}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 方案定制 -->
    <el-dialog title="新建方案" :visible.sync="schemeDialogVisible" width="50%" center id="scheme">
      <div class="scheme_box">
        <el-form :model="schemeForm" :rules="rules" ref="schemeForm" label-width="100px">
          <el-form-item label="服务类型" prop="serveType">
            <el-checkbox-group v-model="schemeForm.serveType">
              <el-checkbox
                :label="item"
                name="type"
                v-for="(item,index) in serveTypeArr"
                :key="index"
              ></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="申请区域" prop="applyArea">
            <v-distpicker
              :placeholders="objArea"
              v-model="schemeForm.applyArea"
              @province="onChangeProvince"
              @city="onChangeCity"
              @area="onChangeArea"
            ></v-distpicker>
            <div :class="applyArea?'applyArea':'applyHide'">请输入地址</div>
          </el-form-item>
          <el-form-item label="公司名称" prop="companyName">
            <el-col :span="20">
              <el-input v-model="schemeForm.companyName"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="方案总价" prop>
            <span>{{schemeForm.planSum}}元</span>
          </el-form-item>
          <el-form-item label="服务价格" prop>
            <span>{{schemeForm.servePrice}}元</span>
          </el-form-item>
          <el-form-item label="备注" prop="notes">
            <el-col :span="20">
              <el-input type="textarea" v-model="schemeForm.notes"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitSchemeForm('schemeForm')">提交方案</el-button>
            <el-button @click="schemeDialogVisible=false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDemandDetails, newAddDnCase } from "@/api/zzzd_admin.js";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      applyArea: false,
      details: {},
      tableData: [],
      //方案定制
      schemeDialogVisible: false,
      serveTypeArr: [],
      //方案定制表单
      schemeForm: {
        serveType: [],
        applyArea: {
          province: "",
          city: "",
          area: "",
        },
        notes: "",
        companyName: "",
        servePrice: "999",
        planSum: "1999",
      },
      objArea: {
        province: "请选择省",
        city: "请选择市",
        area: "请选择区",
      },
      rules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        applyArea: [
          {
            type: "object",
            required: true,
            message: "请输入地址",
            trigger: "blur",
          },
        ],
        serveType: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个服务类型",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    //详情
    getDataDatails() {
      let params = {
        needNo: this.$route.query.needNo,
      };
      getDemandDetails(params)
        .then((res) => {
          console.log("数据详情--", res);
          if (res.status == 0) {
            this.details = res.data;
            this.details.created_at = moment(this.details.created_at).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    //方案弹框事件
    schemeDialogHandle() {
      this.schemeDialogVisible = true;
      if (this.details.notes) {
        this.serveTypeArr = this.details.notes.split("、");
        if (this.details.typeName) {
          this.serveTypeArr.push(this.details.typeName);
        }
      }
    },
    //方案定制 省
    onChangeProvince(val) {
      console.log(val);
      this.schemeForm.applyArea.province = val;
      this.applyArea = false;
    },
    //方案定制 市
    onChangeCity(val) {
      console.log(val);
      this.schemeForm.applyArea.city = val;
      this.applyArea = false;
    },
    //方案定制 区
    onChangeArea(val) {
      console.log(val);
      this.schemeForm.applyArea.area = val;
      this.applyArea = false;
    },
    //方案定制提交事件
    submitSchemeForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //校验判断
          if (
            this.schemeForm.applyArea.province == "" ||
            this.schemeForm.applyArea.city == "" ||
            this.schemeForm.applyArea.area == "" ||
            this.schemeForm.applyArea.province.value == "请选择省" ||
            this.schemeForm.applyArea.city.value == "请选择市" ||
            this.schemeForm.applyArea.area.value == "请选择区"
          ) {
            this.applyArea = true;
            return false;
          }
          let params = {
            diagnosisNo: this.details.needNo,
            solutionContent: { ...this.schemeForm },
          };
          newAddDnCase(params)
            .then((res) => {
              if (res.status == 0) {
                this.$message.success("方案提交成功！");
                this.schemeDialogVisible = false;
                this.$refs[formName].resetFields();
                //重置插件表单
                document.getElementsByClassName('distpicker-address-wrapper')[0].children[0].value = "请选择省";
                document.getElementsByClassName('distpicker-address-wrapper')[0].children[1].value = "请选择市";
                document.getElementsByClassName('distpicker-address-wrapper')[0].children[2].value = "请选择区";
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  mounted() {
    this.getDataDatails();
  },
};
</script>

<style lang="scss" scoped>
.jdindentlist {
  width: 100%;
  padding: 0 20px;
  min-height: 600px;
}
.jdindentList-top {
  width: 100%;
  height: 45px;
  background: #ffffff;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  span {
    color: #108ee9;
    font-size: 18px;
    cursor: pointer;
  }
  div {
    flex: 1;
    font-size: 16px;
    display: flex;
    align-items: center;
  }
}
.result {
  text-align: left;
  padding: 10px 0;
}
.jdindentList-container {
  width: 100%;
  .container_item {
    height: 100px;
    width: 100%;
    background: #ffffff;
    margin-bottom: 20px;
    h1 {
      text-align: left;
      line-height: 45px;
      font-size: 14px;
      font-weight: 500;
      color: #000;
      margin-left: 20px;
    }
    .container_item_box {
      display: flex;
      .container_item_box_item {
        width: 50%;
        text-align: left;
        margin-left: 20px;
        line-height: 40px;
        div {
          display: flex;
          label {
            color: #888888;
            font-size: 12px;
            font-weight: 400;
            width: 80px;
          }
          span {
            color: #333333;
            font-size: 12px;
            font-weight: 400;
          }
        }
      }
    }
  }
}
.el-steps--simple {
  background: #ffffff;
}
/deep/#scheme {
  .scheme_box {
    .distpicker-address-wrapper {
      select {
        min-width: 158px;
      }
    }
    .applyArea {
      color: #f56c6c;
      font-size: 12px;
      line-height: 1;
      padding-top: 4px;
      position: absolute;
      top: 100%;
      left: 0;
    }
    .applyHide {
      display: none;
    }
  }
}
</style>
